import { Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor
} from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable()
export class AuthorizationInterceptor implements HttpInterceptor {

  constructor() { }

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {

    const authToken = localStorage.getItem('SAML');
    // Clone the request and replace the original headers with
    // cloned headers, updated with the authorization.
    if(!request.url.includes(environment.SAML_url) && authToken){
      request = request.clone({
        headers: request.headers.set('AuthorizationSAML', authToken)
      });
    }

    return next.handle(request);
  }
}
